import React, { useState } from "react";
import axios from "axios";
import { Sparkles, ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NewsletterSection = () => {
  const [form, setForm] = useState({ first_name: "", email: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.first_name.trim() || !form.email.trim()) {
      toast.error("Please share your name and email.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, form);
      toast.success("You're subscribed! Talk soon.");
      setForm({ first_name: "", email: "" });
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="newsletter-gradient" data-testid="newsletter-section">
      <div className="container-hc py-20 md:py-28">
        <div className="max-w-3xl">
          <div className="hc-chip chip-light inline-flex" data-testid="newsletter-chip">
            <Sparkles size={14} />
            Activity Schedule
          </div>

          <h2 className="font-serif-display mt-7 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-white">
            Sign up for our <span className="italic">activity schedule.</span>
          </h2>

          <p className="mt-7 text-lg text-white/90 leading-relaxed">
            Get our monthly activity schedule delivered to your inbox — birthdays, bingo nights,
            holiday parties, family meals, sing-alongs, and everything happening around the
            home. So you never miss a moment.
          </p>

          <form onSubmit={submit} className="mt-9 space-y-4 max-w-xl" data-testid="newsletter-form">
            <input
              className="hc-input bg-white"
              placeholder="Your first name"
              value={form.first_name}
              onChange={(e) => setForm({ ...form, first_name: e.target.value })}
              data-testid="newsletter-input-name"
            />
            <input
              type="email"
              className="hc-input bg-white"
              placeholder="your@email.com"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              data-testid="newsletter-input-email"
            />
            <button
              type="submit"
              disabled={loading}
              className="btn-navy w-full justify-center disabled:opacity-60"
              data-testid="newsletter-submit"
            >
              {loading ? (
                <Loader2 size={18} className="animate-spin" />
              ) : (
                <>
                  Send Me the Schedule <ArrowRight size={18} />
                </>
              )}
            </button>
            <p className="text-center text-white/85 text-sm">
              One email a month, max. Unsubscribe anytime.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
